import { render, staticRenderFns } from "./KoreanSpecial.vue?vue&type=template&id=f130a21e&scoped=true"
import script from "./KoreanSpecial.vue?vue&type=script&lang=js"
export * from "./KoreanSpecial.vue?vue&type=script&lang=js"
import style0 from "./KoreanSpecial.vue?vue&type=style&index=0&id=f130a21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f130a21e",
  null
  
)

export default component.exports